const enum RouteTypes {
  DEFAULT,
  AUTH,
  PROTECTED,
  CANDIDATE,
  EMPLOYER,
  INTERNAL,
  EMPLOYER_OR_INTERNAL,
}

export default RouteTypes;
